<template>
  <V-app class="auth-box">
    <div class="loader"/>

    <div class="px-0 px-sm-2 px-md-4 float-left">

      <v-btn small class="mx-1" icon large @click="toggleNightMode()">
        <v-icon>mdi-invert-colors</v-icon>
      </v-btn>
    </div>
    <v-main>
      <v-container fluid fill-height class="pa-0">
        <v-layout align-center justify-center>
          <v-flex xs12 align-self-center>
            <v-card elevation="2" class="login-box rounded-xl" outlined :loading="loading"
                    color="rgba(255, 255, 255, .4)">
              <v-card-actions class="justify-center auth-img-holder">
                <!--                                <v-img src="/media/logo.png" width="100" max-width="100" contain class="elevation-5 rounded-circle"/>-->
              </v-card-actions>

              <v-card-text class="text-center px-8 py-5">

                <v-card-title class="text-center">
                  <div class="mx-auto d-flex align-center">
                    <v-img max-width="100" max-height="100" class="mx-2" src="/media/logo.png"/>
                  </div>
                </v-card-title>

                <v-card-title class="text-center my-4">
                  <span class="mx-auto" v-if="forget_password">فراموشی رمز عبور</span>
                  <span class="mx-auto" v-else-if="registered">ثبت نام</span>
                  <span class="mx-auto" v-else-if="forgetPassword"> فراموشی رمز عبور</span>
                  <span class="mx-auto" v-else>ورود</span>
                </v-card-title>


                <v-text-field v-if="!registered" label="شماره موبایل/نام کاربری" dense type="text"
                              append-icon="mdi-account"
                              id="edit_user"
                              autofocus
                              :disabled="methodSelected=='otp' || forget==true"
                              :error-messages="errors.verify.username === undefined ? [] : errors.verify.username"
                              v-model="username" outlined/>


                <ForgetPassword @passChanged="methodSelected='' ;forget=false;forget_password=false" v-if="forget" :username="username" :code="code"></ForgetPassword>

                <v-btn height="48" v-if="methodSelected=='otp' && forgetPassword===false"
                       :disabled="timeSms > 0" rounded outlined
                       @click="verify"
                       :style="timeSms > 0 ? 'color: #7e7e7e;' : ''" min-width="150">
                  <span v-if="timeSms">ارسال مجدد کد</span>

                  <span id="min">{{ timeSms }}</span>
                </v-btn>

                <v-btn height="48" v-if="methodSelected=='otp' && !forget_password&& forgetPassword"
                       :disabled="time > 0" rounded outlined
                       @click="forgetPass"
                       :style="time >0 ? 'color: #7e7e7e;' : ''" min-width="150">
                  <span v-if="time">ارسال مجدد کد</span>
                  <span>{{ time }}</span>
                </v-btn>
                <num-keypad v-if="methodSelected=='otp'"></num-keypad>

                <v-text-field label="رمز عبور" dense type="password" append-icon="mdi-lock" id="edit_pass"
                              :error-messages="errors.verify.password === undefined ? [] : errors.verify.password"
                              v-if="!registered && !forget_password && !verified && methodSelected=='pass'"
                              hint="حداقل 8 کاراکتر"
                              :rules="[rules.required, rules.min]"

                              v-model="loginpass" outlined/>

<!--                <v-checkbox v-model="remmember" class="ma-0" key="remember"-->
<!--                            v-if="!registered && !forget_password && !verified && methodSelected=='pass'">-->
<!--                  <template v-slot:label>-->
<!--                    <div>مرا به خاطر بسپار</div>-->
<!--                  </template>-->
<!--                </v-checkbox>-->


                <!--                                REGISTER-->
                <v-text-field label="نام" dense type="text" append-icon="mdi-account"
                              v-if="registered && !forget_password && !verified"
                              :error-messages="errors.register.name === undefined ? [] : errors.register.name"
                              v-model="name" outlined/>

                <v-text-field label="نام خانوادگی" dense type="text" append-icon="mdi-account"
                              v-if="registered && !forget_password && !verified"
                              :error-messages="errors.register.lastName === undefined ? [] : errors.register.lastName"
                              v-model="lastName" outlined/>

                <v-text-field v-model="phone" outlined dense label="تلفن همراه"
                              type="number"
                              v-if="registered && !forget_password && !verified"
                              append-icon="mdi-phone"
                              :error-messages="errors.register.phone === undefined ? [] : errors.register.phone"
                              maxlength="11"/>

                <v-text-field v-if="registered && !forget_password && !verified"
                              label="نام کاربری" type="text" dense append-icon="mdi-account"
                              :error-messages="errors.register.username === undefined ? [] : errors.register.username"
                              v-model="registerusername" outlined/>

                <v-text-field label="ایمیل" type="email" dense append-icon="mdi-email"
                              v-if="registered && !forget_password && !verified"
                              :error-messages="errors.register.email === undefined ? [] : errors.register.email"
                              v-model="email" outlined/>

                <v-text-field label="رمز عبور" dense type="password" append-icon="mdi-lock"
                              :error-messages="errors.register.password === undefined ? [] : errors.register.password"
                              v-if="registered && !forget_password && !verified"
                              id="edit_pass"
                              v-model="password" outlined/>
                <button class="btn btn-link "
                        @click="forgetPass"
                        :disabled="time > 0"
                        v-if="!registered && !forget_password && !verified && methodSelected=='pass'">
                  آیا پسورد خود را فراموش کرده اید؟{{ time }}
                </button>


                <v-alert v-if="forget_password && forget_password_send" prominent icon="mdi-check"
                         type="success">
                  {{ $t('text.reset_password_mail_sent') }}
                </v-alert>
                <p class="text-center mb-0" v-if="registered && !forget_password && !verified">

                  قبلا ثبت نام کرده اید؟
                  <v-btn small @click="registered=false">
                    ورود
                  </v-btn>
                </p>

                <v-btn color="primary" min-width="110" :loading="loading"  @click="login"
                       v-on:keydown.enter="login"
                       id="login_submit"
                       v-if="!registered && !forget_password && methodSelected==='pass' && forgetPassword===false">
                  <v-icon>mdi-chevron-right</v-icon>
                  {{ forget_password ? 'تغییر رمز' : 'ورود' }}
                </v-btn>

              </v-card-text>

              <v-divider/>


              <v-card-actions class="justify-center">
                <v-container grid-list-md text-xs-center>

                  <v-layout row wrap justify-center>

                    <v-flex xs10 md4 order-md2>

                      <v-btn block @click="goToGoogle" color="pink"
                             class="white--text"
                             id="login_google"
                             v-if="!registered && !forget_password ">
                        ورود با گوگل
                        <v-icon>mdi-google</v-icon>
                      </v-btn>

                    </v-flex>


                    <v-flex xs10 md4 order-md2>


                      <v-btn block color="purple darken-2" :loading="loadingotp"
                             class="white--text"
                             @click="verify"
                             id="login_sms"
                             :disabled="timerSms > 0"
                             v-if="!registered && !forget_password">
                        ورود با پیامک {{ timeSms }}
                        <v-icon>mdi-cellphone-message</v-icon>
                      </v-btn>


                    </v-flex>
                    <v-flex xs10 md4 order-md2>
                      <v-btn block color="primary"
                             class="white--text"
                             id="login_pass"
                             @click="methodSelected='pass', forget = false, forgetPassword = false"
                             v-if="!registered && !forget_password ">
                        {{ forget_password ? 'تغییر رمز' : 'ورود با رمز' }}
                        <v-icon class="mr-1">mdi-lock</v-icon>
                      </v-btn>

                      <v-btn color="primary" @click="register()" :loading="loading"
                             v-if="registered">
                        <v-icon>mdi-chevron-right</v-icon>
                        ثبت نام

                      </v-btn>

                    </v-flex>

                  </v-layout>
                </v-container>

              </v-card-actions>


            </v-card>
            <p class="text-center mt-5" v-if="!forget_password &&!registered">
              حسابی ندارید؟
              <v-btn small
                     @click="registered = true, forget = false, forgetPassword = false , methodSelected=''">
                هم اکنون ثبت نام کنید!
              </v-btn>
            </p>

          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

  </V-app>
</template>

<script>

import NumKeypad from "./numKeypad";
import {LOGIN, LOGOUT} from "@/core/services/store/auth.module";
import jwtService from "../../../core/services/jwt.service";
import ForgetPassword from "./ForgetPassword";

export default {
  name: "login",

  components: {ForgetPassword, NumKeypad},

  data: () => ({

    code: null,
    rules: {
      required: value => !!value || 'فیلد اجباری می باشد.',
      min: v => v.length >= 8 || 'فیلد شما کوچک تر از 8 کاراکتر است',
      },
    verifyCode: null,

    validateCode: false,
    forget: false,
    time: null,
    timer: null,
    methodSelected: '',
    forgetPassword: false,
    username: '',
    registerusername: '',
    phone: '',
    resend: false,
    email: '',
    name: '',
    lastName: '',
    password: '',
    remmember: false,
    loginpass: '',
    errors: {
      verify: {},
      register: {},
      passlogin: {},
    },
    loading: false,
    loadingotp: false,
    registered: false,
    verified: false,
    errorMessage: "",
    forget_password: false,
    forget_password_send: false,
    showErrorMessage: false,
    showSuccessMessage: false,
    formObject: {
      name: "",
      email: "",
      password: "",
    },
    timerSms: null,
    timeSms: null,
  }),
  mounted() {
    const self = this;
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        self.login();
      }
    });
    let url = window.location.href;
    const start = url.indexOf("?");
    const end = url.indexOf("#");

    url = url.substring(start, end);

    // if (url === '?redirect=qr') return;
    // if (url == '?redirect=Pland') return;

    window.history.pushState('login', 'Title', '/#/login');

    if (start > -1) {

      this.requestApiGet("google/callback" + url)
          .then(({data}) => {
            if (data.status === 200) {
              this.$store.dispatch(LOGOUT)
              this.$store.dispatch(LOGIN, data.data.user)
              return this.checkLogin();
            }
            return this.$toast.error(data.message)
          }).catch(({error}) => {
        console.log(error)
      })
    }
    this.checkLogin();
  },
  beforeDestroy() {
    this.clearIntervalOnClose();
  },
  created() {
    this.$vuetify.rtl = true;
    this.$vuetify.theme.dark = this.getCookie("theme", 'false') === 'true';
    this.$root.$on('Step2', this.loginStep2);
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    backgroundImage() {
      return process.env.BASE_URL + "media/svg/auth-bg.svg";
    }
  },


  methods: {
    goToGoogle(){
      return window.location.replace('https://coreland.sarvland.ir/api/redirect/google')
    },
    checkLogin() {
      if (jwtService.getToken()) {
        this.goReplace('home')
        window.history.pushState('home', 'Title', '/#/home');
      }
    },
    verify() {
      //ورود با پیامک
      //User verification
      const vm = this;
      this.loadingotp = true;
      this.forget = false
      this.forgetPassword = false
      this.errors.verify = {};
      this.requestApiPost('auth/user-verify', {"username": this.username})
          .then(({data}) => {
            this.$toast.success(data.message);
            this.methodSelected = 'otp';
            if (vm.timerSms)
              return;
            vm.timeSms = 180;
            vm.timerSms = setInterval(function () {
              vm.timeSms--;
              if (vm.timeSms === 0) {
                clearInterval(vm.timerSms)
                vm.timerSms = null
              }

            }, 1000)
          })
          .catch(({response}) => {
            if (response.data != null && this.objectLength(response.data.errors) > 0)
              this.errors.verify = response.data.errors;
            if (response.status === 429) {
              if (vm.timerSms)
                return;
              vm.timeSms = data.getResponseHeader("Retry-After");
              vm.timerSms = setInterval(function () {
                vm.timeSms--;
                if (vm.timeSms === 0) {
                  clearInterval(vm.timerSms)
                  vm.timerSms = null
                }
              }, 1000)
              return this.$toast.error(`لطفا به مدت سه دقیقه صبر کنید و دوباره درخواست بدهید.`)

            }
          })
          .finally(() => {
            this.loadingotp = false
          });
    },
    login() {
      this.loading = true;
      this.requestApiGet('auth', {"via": 'pass', "username": this.username, "password": this.loginpass})
          .then(({data}) => {
            this.$toast.success('با موفقیت وارد شدید');
            this.user = data.data
            this.registered = false
            this.$store.dispatch(LOGOUT);
            this.$store.dispatch(LOGIN, data.data.user)
            window.location.reload()
          })
          .catch(({response}) => {
            if (response.data != null && this.objectLength(response.data.errors) > 0)
              this.errors.verify = response.data.errors;
          })

          .finally(() => {
            this.loading = false;
          })


    },
    loginStep2(key) {
      if (this.forgetPassword) {
        return this.sendCode(key);
      }

      this.loading = true;
      this.requestApiGet('auth', {
        "via": 'otp',
        "username": this.english(this.username),
        "code": this.english(key)
      })
          .then(({data}) => {
            this.$toast.success('با موفقیت وارد شدید');
            console.log(data.data)
            this.user = data.data
            this.registered = false
            this.$store.dispatch(LOGOUT);
            this.$store.dispatch(LOGIN, data.data.user)
            window.location.reload()
            // this.verify.phone = data.data.phone;
            // this.setCookie("verifyPhone", this.verify.phone)
            // this.glUserLoggedIn().then((data) => console.log('gl user loggedIn: ', data))
          })
          .catch(({response}) => {
            this.$toast.error(response.data.message);
            if (response.data != null && this.objectLength(response.data.errors) > 0)
              this.errors.passlogin = response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          })


      // this.requestApiPost('auth/verify', {
      //     'phone': this.english(this.phoneNumber),
      //     'password': key,
      // }).then(({data}) => {
      //     this.$store.dispatch('login', {data})
      //
      //     this.$root.user = data;
      //     this.$root.$emit('userUpdate', data);
      //
      //     if (data.firstname)
      //         this.$toast.success(` خوش آمدید ${data.firstname} عزیز.`);
      //     this.goReplace('/');
      //
      // }).catch(({response}) => {
      //     if (response.status === 422) {
      //         this.$toast.error('کد ورود اشتباه است!');
      //         this.wrongNumber();
      //     } else {
      //         this.errors = response.data;
      //     }
      // })
      //     .finally(() => this.$root.$emit('loading', 'false'));
    },
    register() {
      const vm = this;

      this.loading = true;
      this.username=this.phone
      const params = new URLSearchParams();
      params.append('name', this.name);
      params.append('lastName', this.lastName);
      params.append('username', this.registerusername);
      params.append('phone', this.phone);
      params.append('password', this.password);

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      this.requestApiPostLogin('auth/register', params, config)
          .then(({data}) => {
            this.$toast.success('ثبت نام با موفقیت انجام شد');
            this.user = data.data;
            this.loadingotp = true;
            this.forget = false
            this.forgetPassword = false
            this.registered = false
            // this.$toast.success(data.message);
            this.methodSelected = 'otp';
            if (vm.timerSms)
              return;
            vm.timeSms = 180;
            vm.timerSms = setInterval(function () {
              vm.timeSms--;
              if (vm.timeSms === 0) {
                clearInterval(vm.timerSms)
                vm.timerSms = null
              }

            }, 1000)



          })
          .catch(({response}) => {
            if (response.data != null && this.objectLength(response.data.errors) > 0)
              this.errors.register = response.data.errors;


            if (response.data != null && this.objectLength(response.data.errors) > 0)
              this.errors.verify = response.data.errors;
            if (response.status === 429) {
              if (vm.timerSms)
                return;
              vm.timeSms = data.getResponseHeader("Retry-After");
              vm.timerSms = setInterval(function () {
                vm.timeSms--;
                if (vm.timeSms === 0) {
                  clearInterval(vm.timerSms)
                  vm.timerSms = null
                }
              }, 1000)
              return this.$toast.error(`لطفا به مدت سه دقیقه صبر کنید و دوباره درخواست بدهید.`)

            }



          })
          .finally(() => {
            this.loading = false;
          })

    },
    forgetPass() {
      const vm = this;
      this.requestApiPost(`forget-password`, {
        username: this.username
      }).then((response) => {
        this.$toast.success(response.data.message)
        vm.forgetPassword = true
        vm.methodSelected = 'otp'
        if (vm.timer)
          return;
        vm.time = 180;
        vm.timer = setInterval(function () {
          vm.time--;
          if (vm.time === 0) {
            clearInterval(vm.timer)
            vm.timer = null
          }
        }, 1000)
      }).catch(({response}) => {
        if (response.status === 422)
          return this.$toast.error(response.data.errors.username[0])
        if (response.status === 429) {
          if (vm.timer)
            return;
          vm.time = data.getResponseHeader("Retry-After");
          vm.timer = setInterval(function () {
            vm.time--;
            if (vm.time === 0) {
              clearInterval(vm.timer)
              vm.timer = null
            }
          }, 1000)
          return this.$toast.error(`لطفا به مدت سه دقیقه صبر کنید و دوباره درخواست بدهید.`)

        }
      })
    },
    sendCode(key) {
      this.code = key;
      this.requestApiPost(`reset-password`, {
        'code': this.english(key),
        'username': this.english(this.username)
      }).then(({data}) => {
        this.$toast.success(data.message)
        this.methodSelected = ''
        this.forget = true
      }).catch(({response}) => {
        this.$toast.error(response.data.message)
      })
    },
    wrongNumber() {
      let columns = document.getElementById('keypad-column-holder');

      for (let i = 0; i < columns.children.length; i++) {
        if (columns.children[i].classList.contains('put-wrong-class')) {
          columns.children[i].classList.remove('put-wrong-class')
        }
        setTimeout(() => {
          columns.children[i].classList.add('put-wrong-class')
        }, 200)
      }
    },
    editNumber() {
      this.clearIntervalOnClose();
      this.step1 = false;
      this.resend = false;
    },
    clearIntervalOnClose() {
      clearInterval(this.myfunc);
      this.myfunc = undefined;
    },
  }
}
</script>

<style scoped>

.loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(45deg, #0f8, #08f);
  z-index: 0;
  filter: hue-rotate(360deg);
  animation: hue 40000ms infinite linear;
}

@keyframes hue {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

.auth-box {

  background-image: url("/media/svg/auth-bg.svg") !important;

  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
}

@media (min-width: 601px) {
  .login-box {
    margin: 0 auto;
    width: 450px;
  }
}

@media (max-width: 601px) {
  .login-box {
    border: none !important;
    background: none !important;
    box-shadow: none !important;
  }

  hr {
    display: none !important;
  }

  .auth-img-holder {
    transform: translateY(-80%);
    margin-bottom: -32px;
  }
}

@keyframes wrong-code-anm {
  0% {
    opacity: 100%;
    transform: scale(1);
  }
  50% {
    opacity: 50%;
    transform: scale(.4);
  }
  100% {
    opacity: 100%;
    transform: scale(1);
  }
}
</style>
